
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

export default function GuestOnly({ children }) {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return <div style={{ padding: 24 }}></div>; //usunac element css
  if (isAuthenticated) return <Navigate to="/profile" replace />;

  return children;
}
